import { useEffect, useState } from "react";
import { FaUserShield, FaEnvelope, FaUser, FaLock } from "react-icons/fa";
import Button from "../controls/button/button";
import Column from "../layout/column/column";
import Row from "../layout/row/row";
import "./login.css";
import Dialogs from "../dialogs/dialogs";
import TextField from "../controls/text-field/text-field";
import LoginIllustration from "./LoginIllustration.jpg";

/**
 * Login component.
 * @param {ReactDOM.props} props Component properties.
 * @returns Generated component.
 */
const Login = (props) => {
  // Initialize states
  const [login, setLogin] = useState(props?.login ? props.login : "");
  const [password, setPassword] = useState(props?.password ? props.password : "");

  /**
   * Validate handler.
   */
  const validate = () => {
    const loginEl = document.getElementById("login");
    const passEl = document.getElementById("password");
    if (loginEl.value === "") {
      Dialogs.error("Merci de saisir votre identifiant de connexion.", "Identification interrompue");
      document.getElementById("login").focus();
    } else if (passEl.value === "") {
      Dialogs.error("Merci de saisir votre mot de passe.", "Identification interrompue");
      document.getElementById("password").focus();
    } else {
      props?.onValidate?.(loginEl.value, passEl.value);
    }
  };

  /**
   * Forgotten password handler.
   */
  const forgotten = (evt) => {
    const loginEl = document.getElementById("login");
    if (loginEl.value === "") {
      Dialogs.error("Merci d'indiquer votre identifiant de connexion.", "Réinitialisation interrompue");
      document.getElementById("login").focus();
    } else {
      props?.onForgotten?.(loginEl.value);
    }
    evt.preventDefault();
    return true;
  };

  useEffect(() => {
    // document.getElementById('login').focus();
  }, []);
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        overflow: "hidden",
        background: "#ffffff",
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        <img
          src={LoginIllustration}
          alt="Illustration connexion"
          style={{
            maxWidth: 800,
            width: "100%",
            height: "auto",
            opacity: 1,
          }}
        />
      </div>      <div
        style={{
          position: "relative",
          width: 500,
          height: "100vh",
          background: "#fff",
          boxShadow: "-2px 0 8px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: "48px 40px",
          borderRadius: 0,
          zIndex: 10,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", marginBottom: 32 }}>
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              background: "#3b82f6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 16,
            }}
          >
            <span style={{ color: "#fff", fontWeight: 700, fontSize: 38, fontFamily: "Inter, Arial" }}>M</span>
          </div>
          <div style={{ fontWeight: 700, fontSize: 22, color: "#22223b", fontFamily: "Inter, Arial" }}>Login</div>
        </div>
        <div style={{ color: "#64748b", fontSize: 14, marginBottom: 24 }}>Merci de vous identifier pour accéder à votre espace sécurisé.</div>
        <TextField
          id="login"
          label="Identifiant"
         labelIcon={<FaUser style={{ fontSize: 14 }} />}
          dataType="string"
          value={login}
          placeholder="Identifiant"
          onChange={(evt) => setLogin(evt.target.value)}
          style={{ marginBottom: 25 }}
        />
        <TextField
          id="password"
          label="Mot de passe"
           labelIcon={<FaLock style={{ fontSize: 14 }} />}
          dataType="string"
          value={password}
          placeholder="Mot de passe"
          onChange={(evt) => setPassword(evt.target.value)}
          password
          //   style={{ marginBottom: 25, background: "#e7f0fd" }}
        />
      
        <Button onClick={validate} large style={{ marginTop: 28, width: "100%" }}>
          Connexion
          <FaUserShield />
        </Button>
          <div style={{ display: "flex", justifyContent: "center", margin: "50px 0 0 0" }}>
          <a href="/" onClick={forgotten} style={{ fontSize: 13, color: "#3b82f6", textDecoration: "none" }}>
            Mot de passe oublié ?
          </a>
        </div>
      </div>
    </div>
  );
};
export default Login;
